/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_NoteInputs */

const en_visa_l1_note = /** @type {(inputs: Visa_L1_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some organizations may have additional filing options or process advantages depending on their structure and prior U.S. operations.`)
};

const pt_visa_l1_note = /** @type {(inputs: Visa_L1_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algumas organizações podem ter opções de apresentação adicionais ou vantagens de processo dependendo de sua estrutura e operações anteriores nos EUA.`)
};

const es_visa_l1_note = /** @type {(inputs: Visa_L1_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunas organizaciones pueden tener opciones de presentación adicionales o ventajas de proceso según su estructura y operaciones previas en EE. UU.`)
};

/**
* | output |
* | --- |
* | "Some organizations may have additional filing options or process advantages depending on their structure and prior U.S. operations." |
*
* @param {Visa_L1_NoteInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_note = /** @type {((inputs?: Visa_L1_NoteInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_NoteInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_note(inputs)
	if (locale === "es") return es_visa_l1_note(inputs)
	return en_visa_l1_note(inputs)
});